import { render } from "./infoPayment.vue?vue&type=template&id=18d36842&scoped=true"
import script from "./infoPayment.vue?vue&type=script&lang=js"
export * from "./infoPayment.vue?vue&type=script&lang=js"

import "./infoPayment.vue?vue&type=style&index=0&id=18d36842&scoped=true&lang=css"

import exportComponent from "D:\\Development\\VSTS.Git\\FleuristeBergeron\\Spec_2.0\\Solutions\\WWW\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18d36842"]])

export default __exports__